module.exports = __webpack_public_path__ + "img/goal-two-br.ba60cb15.png";